import { Box, IconButton, Button, Typography, useTheme, Dialog, DialogTitle, DialogContent, DialogActions, FormControlLabel, Checkbox } from "@mui/material";
import { useEffect, useState } from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { useAuth } from "../../AuthContext";
import { tokens } from "../../theme";
import { ToastContainer, toast } from "react-toastify";
import { Form } from "react-bootstrap";
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import 'react-toastify/dist/ReactToastify.css';
import Nodata from '../../assets/errors/nodata.png';
import QRCode from "qrcode";
import logo from "../../assets/logo.png";
import QrCodeIcon from '@mui/icons-material/QrCode';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CloseIcon from '@mui/icons-material/Close';

const Inventory = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [staffs, setStaffs] = useState([]);
  const [validAssets, setValidAssets] = useState([]);
  const [loaning, setLoaning] = useState([]);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { getData, addData, updateData, deleteData } = useAuth();

  // Form state
  const [formData, setFormData] = useState({
    sku: "",
    type:'purchased',
    description: '',
    category: "",
    categoryType: "",
    location: "",
    serialNumber: "",
    purchaseddate: new Date().toISOString().split('T')[0],
    suplier: '',
    quantity: '0',
    deliveredDate: '',
    costprice: '0',
    product_condition: '',
    deliveredStatus: '0',
    comment: '',
    assignedTo: "",
    isVerified: '0',
    verifiedDate: '',
    status: '0'
  });

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getData('proccess.php', 'inventory'); // Fetch inventory data
        if (response.success) {
          setItems(Array.isArray(response.data) ? response.data : []);
        } else {
          toast.error(response.message || "Failed to load asset data");
        }

        const validAssetsResponse = await getData("proccess.php", "inventory");
        if (validAssetsResponse.success) {
          const validItems = Array.isArray(validAssetsResponse.data)
            ? validAssetsResponse.data.filter(
                (item) =>
                  !["discarded", "damaged", "refurbished"].includes(
                    (item.product_condition || "").toLowerCase()
                  )
              )
            : [];
          setValidAssets(validItems);
        }

        const staffsResponse = await getData("proccess.php", "staffs");
        if (staffsResponse.success) {
          setStaffs(
            Array.isArray(staffsResponse.data) ? staffsResponse.data : []
          );
        } else {
            //toast.error(staffsResponse.message || "Failed to load staffs data");
        }

        const loaningResponse = await getData("proccess.php", "loaning");
        if (loaningResponse.success) {
          setLoaning(
            Array.isArray(loaningResponse.data) ? loaningResponse.data : []
          );
        } else {
            //toast.error(loaningResponse.message || "Failed to load loaning data");
        } 

      } catch (err) {
        toast.error("Network error: Failed to fetch asset data");
        console.error("Fetch error:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [getData]);

  const downloadSkuQR = async (item) => {
    try {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const width = 400;
      const height = 500;

      canvas.width = width;
      canvas.height = height;

      // white background
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, width, height);

      // load logo
      const logoImg = new Image();
      logoImg.src = logo;

      logoImg.onload = async () => {

        // draw logo
        const logoSize = 305;
        ctx.drawImage(
          logoImg,
          (width - logoSize) / 2,
          20,
          logoSize,
          75
        );

        // generate QR
        const qrDataUrl = await QRCode.toDataURL(item.sku, {
          margin: 1,
          width: 250,
        });

        const qrImg = new Image();
        qrImg.src = qrDataUrl;

        qrImg.onload = () => {

          const qrSize = 250;

          ctx.drawImage(
            qrImg,
            (width - qrSize) / 2,
            120,
            qrSize,
            qrSize
          );

          // SKU text
          ctx.fillStyle = "#000";
          ctx.font = "bold 28px Arial";
          ctx.textAlign = "center";

          ctx.fillText(
            item.sku,
            width / 2,
            430
          );

          // download PNG
          const link = document.createElement("a");
          link.download = `${item.sku}_qr.png`;
          link.href = canvas.toDataURL("image/png");
          link.click();
        };
      };
    } catch (error) {
      console.error(error);
      toast.error("Failed to generate QR code");
    }
  };

  const generateSKU = () => {
    const prefix = "STEAM";

    if (!items || items.length === 0) {
      return `${prefix}000001`;
    }

    // Extract numeric parts from existing SKUs
    const numbers = items
      .map(item => item.sku)
      .filter(Boolean)
      .map(sku => parseInt(sku.replace(prefix, "")))
      .filter(num => !isNaN(num));

    const maxNumber = numbers.length > 0 ? Math.max(...numbers) : 0;

    const nextNumber = maxNumber + 1;

    return `${prefix}${String(nextNumber).padStart(6, "0")}`;
  };

  const handleAddClick = () => {
    setFormData({
      sku: generateSKU(),
      type:'purchased',
      description: '',
      category: "",
      categoryType: "",
      location: "",
      serialNumber: "",
      purchaseddate: new Date().toISOString().split('T')[0],
      suplier: '',
      quantity: '0',
      deliveredDate: '',
      costprice: '0',
      product_condition: '',
      deliveredStatus: '0',
      comment: '',
      assignedTo: "",
      isVerified: '0',
      verifiedDate: '',
      status: '0'
    });
    setOpenAddDialog(true);
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    setFormData({
      sku: item.sku || '',
      type: item.type || 'purchased',
      description: item.description || '',
      category: item.category || '',
      categoryType: item.categoryType || '',
      location: item.location || '',
      serialNumber: item.serialNumber || '',
      purchaseddate: item.purchaseddate || new Date().toISOString().split('T')[0],
      suplier: item.suplier || '',
      quantity: item.quantity || '',
      deliveredDate: item.deliveredDate || '',
      costprice: item.costprice || '',
      product_condition: item.product_condition || '',
      deliveredStatus: item.deliveredStatus?.toString() || '0',
      comment: item.comment || '',
      assignedTo: item.assignedTo || '',
      isVerified: item.isVerified?.toString() || '0',
      verifiedDate: item.verifiedDate || '',
      status: item.status?.toString() || '0'
    });
    setOpenEditDialog(true);
  };

  const handleDeleteClick = (item) => {
    setItemToDelete(item);
    setOpenDeleteDialog(true);
  };

  const handleAssetsDownload = async () => {
    try {      
      const response = await getData('proccess.php', 'inventory'); // Fetch inventory data
      if (response.success) {
        const validItems = Array.isArray(response.data)
          ? response.data.filter(
              (item) =>
                !["discarded", "damaged", "refurbished"].includes(
                  (item.product_condition || "").toLowerCase()
                )
            )
          : [];
        setValidAssets(validItems);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch asset data");
      return;
    }
  };

  const handleDeleteConfirm = async () => {
    try {
      const response = await deleteData('proccess.php', 'inventory', itemToDelete.id); // Delete inventory item by ID
      if (response.success) {
        toast.success(`Asset item deleted successfully`);
        setItems(items.filter(item => item.id !== itemToDelete.id));
      } else {
        toast.error(response.message || "Failed to delete asset item");
      }
    } catch (err) {
      toast.error("Network error: Failed to delete asset item");
      console.error("Delete error:", err);
    }
    setOpenDeleteDialog(false);
    setItemToDelete(null);
  };

  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? "0" : "1") : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      let response;
      
      if (selectedItem) {
        // Update existing inventory item
        response = await updateData('proccess.php', 'inventory', formData, selectedItem.id); // Update inventory item
        if (response.success) {
          toast.success(`Asset item updated successfully`);
          setItems(response.data);
          handleAssetsDownload();
        }
      } else {
        // Add new inventory item
        response = await addData('proccess.php', 'inventory', formData); // Add inventory item
        if (response.success) {
          toast.success(`Asset item added successfully`);
          setItems(response.data); // Assuming response.data contains the new item
          handleAssetsDownload();
        }
      }

      if (!response.success) {
        toast.error(response.message || "Operation failed");
      }
    } catch (err) {
      toast.error("Network error: Operation failed");
      console.error("Operation error:", err);
    }
    setOpenEditDialog(false);
    setOpenAddDialog(false);
    setSelectedItem(null);
  };

  // Export to Excel function
  const exportToExcel = () => {
    if (validAssets.length === 0) {
      toast.warning("No data to export");
      return;
    }

    try {
      // Create CSV content
      const headers = [
        'ID',
        'SKU',
        'type',
        'description',
        'category',
        'Category Type',
        'Location',
        'Serial Number',
        'Purchased Date',
        'Supplier',
        'Quantity',
        'Delivered Date',
        'Cost Price (N$)',
        'Condition',
        'Delivered Status',
        'Status',
        'Comment',
        'Assigned To',
        'Is Verified',
        'Verified Date',
        'Date Created'
      ];

      const csvContent = validAssets.map(item => [
        item.id,
        `"${item.sku || ''}"`,
        `"${item.type || ''}"`,
        `"${item.description || ''}"`,
        `"${item.category || ''}"`,
        `"${item.categoryType || ''}"`,
        `"${item.location || ''}"`,
        `"${item.serialNumber || ''}"`,
        `"${item.purchaseddate || ''}"`,
        `"${item.suplier || ''}"`,
        item.quantity || '0',
        `"${item.deliveredDate || ''}"`,
        item.costprice || '0',
        `"${item.product_condition || ''}"`,
        `"${getDeliveredStatusText(item.deliveredStatus)}"`,
        `"${getStatusText(item.status)}"`,
        `"${item.comment || ''}"`,
        `"${item.assignedTo || ''}"`,
        `"${item.isVerified === '0' ? 'Yes' : 'No'}"`,
        `"${item.verifiedDate || ''}"`,
        `"${item.dateCreated || ''}"`
      ].join(','));

      // Combine headers and data
      const xlsxContent = [headers.join(','), ...csvContent].join('\n');

      // Create and download file
      const blob = new Blob([xlsxContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `inventory_${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      toast.success("Inventory data exported successfully");
    } catch (error) {
      console.error('Export error:', error);
      toast.error("Failed to export data");
    }
  };

  // Helper functions for status text
  const getDeliveredStatusText = (status) => {
    const statusMap = {
      0: 'Not Delivered',
      1: 'Partially Delivered',
      2: 'Fully Delivered'
    };
    return statusMap[status] || 'Not Delivered';
  };

  const getStatusText = (status) => {
    const statusMap = {
      0: 'Available',
      1: 'Unavailable',
      2: 'Damaged'
    };
    return statusMap[status] || 'Available';
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 0.5, minWidth: 70 },
    { field: "sku", headerName: "SKU", flex: 1, minWidth: 120 },
    { field: "type", headerName: "Type", flex: 1, minWidth: 120 },
    { field: "description", headerName: "Description", flex: 1, minWidth: 120 },
    { field: "category", headerName: "Category", flex: 1, minWidth: 120 },
    { field: "categoryType", headerName: "Category Type", flex: 1, minWidth: 120 },
    { field: "location", headerName: "Location", flex: 1, minWidth: 120 },
    { field: "serialNumber", headerName: "Serial Number", flex: 1, minWidth: 120 },
    { field: "purchaseddate", headerName: "Purchased Date", flex: 1, minWidth: 120 },
    { field: "suplier", headerName: "Supplier", flex: 1, minWidth: 120 },
    { field: "quantity", headerName: "Quantity", flex: 1, minWidth: 120, renderCell: (params) => params.row.quantity || '0' },
    { field: "deliveredDate", headerName: "Delivered Date", flex: 1, minWidth: 120 },
    { field: "costprice", headerName: "Cost Price (N$)", flex: 1, minWidth: 130, renderCell: (params) => {
      const cost = parseFloat(params.row.costprice) || 0;
      return(
        <Typography variant="h4" fontWeight={700} paddingTop={'.7rem'} color={cost > 0 ? colors.orange[400] : colors.dark[400]}>
          {cost.toLocaleString()}
        </Typography>
      )
    } },
    { field: "product_condition", headerName: "Condition", flex: 1, minWidth: 120 },
    {
      field: "deliveredStatus",
      headerName: "Delivered Status",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        
        const statusColor = {
          'Not Delivered': colors.red[400],
          'Patially Delivered': colors.orange[400],
          'Fully Delivered': colors.blue[400]
        };
        return (
          <Typography color={statusColor[params.row.deliveredStatus]}>
            {params.row.deliveredStatus || 'Not Delivered'}
          </Typography>
        );
      }
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        const statusText = {
          0: 'Available',
          1: 'Unavailable',
          2: 'Damaged'
        };
        const statusColor = {
          0: colors.blue[400],
          1: colors.orange[400],
          2: colors.red[400]
        };
        return (
          <Typography color={statusColor[params.row.status]}>
            {statusText[params.row.status] || 'Available'}
          </Typography>
        );
      }
    },
    { field: "comment", headerName: "Comment", flex: 1, minWidth: 120 },
    { field: "assignedTo", headerName: "Assigned To", flex: 1, minWidth: 120,
        renderCell: (params) => (
        <Box display="flex" alignItems={'center'} justifyContent={'center'} padding={'.5rem 0'}>
          {params.value ? (
            <img
                src={
                    `https://mindsinaction.com.na/assets/media/pictures/${staffs.find((s) => s.Id === params.value)?.image}` ||
                    "https://via.placeholder.com/40"
                }
                alt="Profile"
                style={{ width: 40, height: 40, borderRadius: "50%", marginRight: 8 }}
            />
          ):(
            <Typography color={colors.dark[400]}>Unassigned</Typography>
          )}
            
        </Box>
      )
    },
    {
      field: "isVerified",
      headerName: "Is Verified",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <Box>
          {params.row.isVerified === 0 ? <CheckBoxIcon color="success" /> : <CloseIcon color="error" />}
        </Box>
      )
    },
    { field: "verifiedDate", headerName: "Verified Date", flex: 1, minWidth: 120 },
    { field: "dateCreated", headerName: "Date Created", flex: 1, minWidth: 120 },
    {
      field: "actions",
      headerName: "Actions",
      width: 160,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Box display="flex" gap="8px">

          <IconButton
            onClick={() => downloadSkuQR(params.row)}
            sx={{ color: colors.green[400] }}
          >
            <QrCodeIcon />
          </IconButton>

          <IconButton
            onClick={() => handleEditClick(params.row)}
            sx={{ color: colors.blue[400] }}
          >
            <EditNoteOutlinedIcon />
          </IconButton>

          <IconButton
            onClick={() => handleDeleteClick(params.row)}
            sx={{ color: colors.red[400] }}
          >
            <DeleteForeverOutlinedIcon />
          </IconButton>

        </Box>
      ),
    }
  ];

  const NoDataOverlay = () => {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100%"
        color={colors.dark[400]}
      >
        <img
          src={Nodata}
          alt="No data"
          style={{ width: 150, marginBottom: 16 }}
        />
        <Typography variant="h6">No inventory items available</Typography>
      </Box>
    );
  };

  return (
    <Box m={"10px"}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      {/* Add/Edit Dialog */}
      <Dialog
        open={openEditDialog || openAddDialog}
        onClose={() => {
          setOpenEditDialog(false);
          setOpenAddDialog(false);
          setSelectedItem(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{selectedItem ? "Edit Asset Item" : "Add New Asset Item"}</DialogTitle>
        <DialogContent>
          <Form onSubmit={handleSubmit} style={{ width: "100%", padding: "1rem" }}>
            <Box display={"flex"} gap={"1rem"} width={"100%"} mb={"1rem"} flexWrap="wrap">
              
              <TextField
                style={{ width: "100%" }}
                id="description"
                name="description"
                label="Description"
                variant="standard"
                value={formData.description}
                onChange={handleFormChange}
                minRows={6}
                maxRows={12}
                multiline
                required
              />
              <TextField
                style={{ width: "48%" }}
                id="sku"
                name="sku"
                label="SKU"
                variant="standard"
                value={formData.sku}
                InputProps={{ readOnly: true }}
              />
              <TextField
                select
                style={{ width: "48%" }}
                id="type"
                name="type"
                label="Type"
                variant="standard"
                value={formData.type}
                onChange={handleFormChange}
                required
                SelectProps={{ native: true }}
              >
                <option value="purchased">Purchased</option>
                <option value="donated">Donated</option>
              </TextField>

              <TextField
                select
                style={{ width: "48%" }}
                id="category"
                name="category"
                label="Category"
                variant="standard"
                value={formData.category}
                onChange={handleFormChange}
                required
                SelectProps={{ native: true }}
              >
                <option value="">Select Category</option>
                <option value="Electronics">Electronics</option>
                <option value="Furniture">Furniture</option>
                <option value="Office Supplies">Office Supplies</option>
                <option value="Vehicle">Vehicle</option>
                <option value="Tools & Equipment">Tools & Equipment</option>
                <option value="Others">Others</option>
              </TextField>
              <TextField
                select
                style={{ width: "48%" }}
                id="categoryType"
                name="categoryType"
                label="Category Type"
                variant="standard"
                value={formData.categoryType}
                onChange={handleFormChange}
                required
                SelectProps={{ native: true }}
              >
                <option value="">Select Category Type</option>
                <option value="Laptop">Laptop</option>  
                <option value="Desktop">Desktop</option>
                <option value="Monitor">Monitor</option>
                <option value="Printer">Printer</option>
                <option value="Chair">Chair</option>
                <option value="Table">Table</option>
                <option value="Stationery">Stationery</option>
                <option value="Car">Car</option>
                <option value="Van">Van</option>
                <option value="Truck">Truck</option>
                <option value="Buss">Buss</option>
                <option value="Power Tools">Power Tools</option>
                <option value="Hand Tools">Hand Tools</option>
                <option value="Robotics Kit">Robotics Kit</option>
                <option value="Electronics Kit">Electronics Kit</option>
                <option value="Twin Science Kit">Twin Science Kit</option>
                <option value="Mechatronics Kit">Mechatronics Kit</option>
                <option value="Charger">Charger</option>
                <option value="Others">Others</option>
              </TextField>
              <TextField
                style={{ width: "48%" }}
                id="location"
                name="location"
                label="Location"
                variant="standard"
                value={formData.location}
                onChange={handleFormChange}
                required
              />
              <TextField
                style={{ width: "48%" }}
                id="serialNumber"
                name="serialNumber"
                label="Serial Number"
                variant="standard"
                value={formData.serialNumber}
                onChange={handleFormChange}
              />
              <TextField
                style={{ width: "48%" }}
                id="purchaseddate"
                name="purchaseddate"
                label="Purchased Date"
                type="date"
                variant="standard"
                value={formData.purchaseddate}
                onChange={handleFormChange}
                required
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                style={{ width: "48%" }}
                id="suplier"
                name="suplier"
                label="Supplier"
                variant="standard"
                value={formData.suplier}
                onChange={handleFormChange}
                required
              />
              <TextField
                style={{ width: "48%" }}
                id="quantity"
                name="quantity"
                label="Quantity"
                type="number"
                variant="standard"
                value={formData.quantity}
                onChange={handleFormChange}
                required
              />

              <TextField
                style={{ width: "48%" }}
                id="deliveredDate"
                name="deliveredDate"
                label="Delivered Date"
                type="date"
                variant="standard"
                value={formData.deliveredDate}
                onChange={handleFormChange}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                style={{ width: "48%" }}
                id="costprice"
                name="costprice"
                label="Cost Price (N$)"
                type="number"
                variant="standard"
                value={formData.costprice}
                onChange={handleFormChange}
                required
              />
              <TextField
                select
                style={{ width: "48%" }}
                id="product_condition"
                name="product_condition"
                label="Condition"
                variant="standard"
                value={formData.product_condition}
                onChange={handleFormChange}
                required
                SelectProps={{ native: true }}
              >
                <option value="New">New</option>
                <option value="Used">Used</option>
                <option value="Refurbished">Refurbished</option>
                <option value="Damaged">Damaged</option>
                <option value="Discarded">Discarded</option>
              </TextField>
              <TextField
                select
                style={{ width: "48%" }}
                id="deliveredStatus"
                name="deliveredStatus"
                label="Delivered Status"
                variant="standard"
                value={formData.deliveredStatus}
                onChange={handleFormChange}
                required
                SelectProps={{ native: true }}
              >
                <option value="1">Not Delivered</option>
                <option value="2">Partially Delivered</option>
                <option value="3">Fully Delivered</option>
              </TextField>
              
              <TextField select name="assignedTo" label="Assigned To" style={{ width: "48%" }}
                variant="standard"
                value={formData.assignedTo} onChange={handleFormChange} SelectProps={{ native: true }}>
                <option value="">Select User</option>
                  {staffs.map((user) => (
                    <option key={user.Id} value={user.Id}>
                      {user.FirstName} {user.LastName}
                    </option>
                ))}
              </TextField>
              <TextField
                select
                style={{ width: "48%" }}
                id="isVerified"
                name="isVerified"
                label="Is Verified"
                variant="standard"
                value={formData.isVerified}
                onChange={handleFormChange}
                required
                SelectProps={{ native: true }}
              >
                <option value="0">Yes</option>
                <option value="1">No</option>
              </TextField>
              <TextField
                style={{ width: "48%" }}
                id="verifiedDate"
                name="verifiedDate"
                label="Verified Date"
                type="date"
                variant="standard"
                value={formData.verifiedDate}
                onChange={handleFormChange}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                style={{ width: "100%" }}
                id="comment"
                name="comment"
                label="Comment"
                variant="standard"
                value={formData.comment}
                onChange={handleFormChange}
                multiline
                rows={4}
              />
              {/* // checkbox for status */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.status === "0"}
                    onChange={handleFormChange}
                    name="status"
                  />
                }
                label={formData.status !== "0" ? "Unavailable" : "Available"}
              />
            </Box>
          </Form>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenEditDialog(false);
              setOpenAddDialog(false);
              setSelectedItem(null);
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            sx={{ backgroundColor: colors.blue[400] }}
            variant="contained"
            endIcon={<SendIcon />}
          >
            {selectedItem ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this asset item?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
          <Button
            onClick={handleDeleteConfirm}
            sx={{ backgroundColor: colors.red[400] }}
            variant="contained"
            startIcon={<DeleteIcon />}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Box mb={"30px"} ml={"15px"} mr={"15px"} display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
        <Box flex={1}>
          <Typography
            variant="h4"
            color={colors.dark[400]}
            fontWeight={"bold"}
            sx={{ mb: "5px" }}
          >
            Asset Management
          </Typography>
          <Typography variant="h5" color={colors.blue[400]}>
            Manage asset items
          </Typography>
        </Box>
        <Box display="flex" gap="1rem">
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={exportToExcel}
            sx={{
              borderColor: colors.green[400],
              color: colors.green[400],
              '&:hover': {
                backgroundColor: colors.green[50],
                borderColor: colors.green[500],
              }
            }}
          >
            Export Excel
          </Button>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleAddClick}
            sx={{
              backgroundColor: colors.blue[400],
              '&:hover': {
                backgroundColor: colors.blue[500],
              }
            }}
          >
            Add Asset Item
          </Button>
        </Box>
      </Box>
      <Divider component="" />
      <Box sx={{ height: 'calc(100vh - 300px)', width: "100%" }} backgroundColor={colors.dark[300]} padding={".2rem"} mt={"1rem"}>
        <DataGrid
          rows={items}
          columns={columns}
          getRowId={(row) => row.id}
          loading={loading}
          sx={{
            border: "none",
            ".MuiDataGrid-cell": {
              borderBottom: "none",
              backgroundColor: "none"
            },
            ".MuiDataGrid-toolbarContainer": {
              padding: "10px",
              backgroundColor: colors.primary[900],
              borderBottom: "none",
            },
            ".MuiDataGrid-quickFilter": {
              padding: "8px",
              borderRadius: "4px",
              border: `1px solid ${colors.primary[100]}`,
            },
            ".MuiDataGrid-columnHeaders": {
              backgroundColor: colors.primary[900],
            },
            ".MuiDataGrid-footerContainer": {
              backgroundColor: colors.primary[900],
            },
          }}
          slots={{
            toolbar: () => (
              <div>
                <GridToolbarQuickFilter />
              </div>
            ),
            noRowsOverlay: NoDataOverlay,
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: {
                debounceMs: 500,
                placeholder: "Search...",
              },
            },
          }}
        />
      </Box>
      <Box sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 1rem',
        marginTop: '1rem'
      }}> 
        <Typography variant="h3" color={colors.dark[400]} fontWeight={"bold"}>
          Total Asset Value:
        </Typography>
        <Typography variant="h3" color={colors.green[400]} fontWeight={"bold"}>
          N${
            items
              .filter(
                (item) =>
                  !["discarded", "damaged", "refurbished"].includes(
                    (item.product_condition || "").toLowerCase()
                  )
              )
              .reduce(
                (total, item) =>
                  total +
                  (parseFloat(item.costprice || 0) *
                    parseInt(item.quantity || "0")),
                0
              )
              .toLocaleString()
          }
        </Typography>
      </Box>
    </Box>
  );
};

export default Inventory;